import { VenueDate } from '@/domain/project-venue-dates/entities/project-venue-dates.entity';

import { VenueDateDto } from './project-venue-dates.dto.schema';

export class VenueDateMapper {
  static dtoToEntity(dto: VenueDateDto): VenueDate {
    return {
      id: dto.id,
      name: dto.name,
      date: dto.startDate,
      models: {
        env: dto.models?.env || '',
        ess: dto.models?.ess || '',
      },
      stats: {
        totalAll:
          (dto.results?.ess?.stats?.totalMen || 0) +
          (dto.results?.ess?.stats?.totalOther || 0) +
          (dto.results?.ess?.stats?.totalWomen || 0),
        totalMen: dto.results?.ess?.stats?.totalMen || 0,
        totalOther: dto.results?.ess?.stats?.totalOther || 0,
        totalWomen: dto.results?.ess?.stats?.totalWomen || 0,
      },
      properties: {
        presetId: dto?.properties?.presetId,
        customAvgCapacity: dto?.properties?.customAvgCapacity || false,
        avgCapacity: dto?.properties?.avgCapacity || 0,
      },
    };
  }

  static entityToDto(venueDate: VenueDate): Partial<VenueDateDto> {
    return {
      name: venueDate.name,
      properties: {
        presetId: venueDate.properties?.presetId,
        customAvgCapacity: venueDate.properties?.customAvgCapacity || false,
        avgCapacity:
          venueDate.properties?.customAvgCapacity &&
          venueDate.properties?.avgCapacity
            ? venueDate.properties?.avgCapacity
            : undefined,
      },
    };
  }
}
